<nav class="navbar navbar-expand-md  py-0">

  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="d-none d-md-block pl-4 pr-4">
        <div class="business-header">
          <div class="business">{{businessName}}</div>
          <div class="permit">Permit No {{permitNo}}</div>
        </div>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'overview'}">
        <a class="nav-link" routerLink="/app/dashboard">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Overview" style="font-size:1.5em"
                class="fas fa-home"></i></div>
            <div class="section-label text-md-center md-text-left">Overview</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'transactions'}">
        <a class="nav-link" routerLink="/app/transactions">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Water Usage" style="font-size:1.5em"
                class="fas fa-tint"></i></div>
            <div class="section-label text-md-center md-text-left">Water Usage</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'vehicles'}">
        <a class="nav-link" routerLink="/app/vehicles">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Vehicles" style="font-size:1.5em"
                class="fas fa-truck"></i></div>
            <div class="section-label text-md-center md-text-left">Vehicles</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'billing'}">
        <a class="nav-link" routerLink="/app/billing">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Billing" style="font-size:1.5em"
                class="fas fa-comment-dollar"></i></div>
            <div class="section-label text-md-center md-text-left">Billing</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'myprofile'}">
        <a class="nav-link" routerLink="/app/account">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="My Profile" style="font-size:1.5em"
                class="fas fa-user-circle"></i></div>
            <div class="section-label text-md-center text-left">Account</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'permitusers'}">
        <a class="nav-link" routerLink="/app/user-accounts">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Permit sub user accounts"
                style="font-size:1.5em; width: 110px;" class="fas fa-id-card"></i></div>
            <div class="section-label text-md-center md-text-left" style="width: 110px;">Operator Accounts</div>
          </div>
        </a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'contactus'}">
        <a class="nav-link" routerLink="/app/contactus">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Contact Us" style="font-size:1.5em"
                class="far fa-envelope"></i></div>
            <div class="section-label text-md-center">Contact Us</div>
          </div>
        </a>
      </li>
      <li class="nav-item" [ngClass]="{'selected-section': selectedSection == 'help'}">
        <a class="nav-link" routerLink="/app/help">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Help" style="font-size:1.5em"
                class="fas fa-question-circle"></i></div>
            <div class="section-label text-md-center">Help</div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" (click)="logout()">
          <div>
            <div class="d-none d-md-block text-center section-icon"><i title="Logout" style="font-size:1.5em"
                class="fas fa-sign-out-alt"></i></div>
            <div class="section-label text-md-center">Logout</div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</nav>
<cli-yes-cancel-modal #logoutModal [id]="'logoutModal'"
  [message]="'Are you sure you want to log out?'"></cli-yes-cancel-modal>